// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-gradient[data-v-725d83c9]{background:linear-gradient(90deg,rgba(0,0,0,.61),rgba(39,48,59,.12))}@media(min-width:400px){.custom-gradient[data-v-725d83c9]{background:linear-gradient(90deg,rgba(0,0,0,.61) 27.33%,rgba(39,48,59,.12) 47.64%)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
